var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":"https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/web/build/dist/imgs/loading.gif","alt":"loading"}})])
}]

export { render, staticRenderFns }